import {Expose, Type} from 'class-transformer';
import {GetLocationExtraInformationDto} from "./get-location-extra-information.dto";

export class BuildingLocationDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'address_id' })
  addressId: number;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'extra_information' })
  @Type(() => GetLocationExtraInformationDto)
  extraInformation: GetLocationExtraInformationDto;
}
